import { Adapter } from './adapter';
import { Error } from '@app/models/_index';
import { ErrorInterface } from '@app/interfaces/_index';

/**
 * Adapt raw error CMS object to Error model
 * NOTE: The item fields are the default json property names.
 */
export class ErrorAdapter implements Adapter<Error> {
  /**
   * Adapt data item into a Error model.
   * @param item - data item Error Interface to be transformed
   * @returns - returns an adapted Error model
   */
  adapt(item: ErrorInterface): Error {
    let error: Error;
    if (item) {
      error = new Error(
        item.modified,
        item.acf && item.acf.display_notification,
        item.content && item.content.rendered
      );
    }
    return error;
  }
}
